import { ReactElement, type FC } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useMedia } from '@pp/core/src/hooks/useMedia';

import { TableTabs } from '../../../../components/tableTabs/TableTabs';
import { RecentResultDetail } from '../../../recentResultDetail/RecentResultDetail';
import { MobileTableSheet } from '../../../tableSheet/mobileTableSheet/MobileTableSheet';
import { TableBetsConnected } from '../../../tableSheet/tableBets/TableBetsConnected';
import { InGameHistoryConnected } from '../../../tableSheet/tableHistory/InGameHistoryConnected';
import { TableStatsConnected } from '../../../tableSheet/tableStats/TableStatsConnected';
import { TableTopConnected } from '../../../tableSheet/tableTop/TableTopConnected';

import styles from './TableSheetCellConnected.module.css';

const componentMap: Record<string, ReactElement> = {
  BETS_SHORT: <TableBetsConnected />,
  HISTORY: <InGameHistoryConnected />,
  STATISTICS_TOP: <TableTopConnected />,
  STATISTICS_STATS: <TableStatsConnected />,
};

export const TableSheetCellConnected: FC = () => {
  const isWide = useMedia('(min-width: 1024px) and (min-height: 500px)');

  return isWide ? (
    <div className={styles.tableSheetCellContainer}>
      <RecentResultDetail />
      <TableTabs
        classNameLabel={styles.tableSheetHeader}
        tabs={Object.keys(componentMap).map((tab) => ({
          label: <L10nText tk={tab} />,
          content: componentMap[tab],
          key: tab,
        }))}
      />
    </div>
  ) : (
    <MobileTableSheet />
  );
};
